import * as yup from 'yup';

export const createNewPlanificadorSchema = yup.object({
  flota: yup.string().required('Flota es requerida'),
  fecha_inicio: yup.string().optional(),

  // helper
  tipoPlanificador: yup.string().optional(),
  // fecha_final: yup
  //   .string()
  //   .optional()
  //   .when('tipoPlanificador', {
  //     is: TipoPlanificador.MANUAL,
  //     then: schema => schema.required('La fecha final es requerida'),
  //   }),
});

export const permaBlockTimeSchema = yup.object({
  isUnblockRequest: yup.boolean().optional(),

  motivo: yup
    .string()
    .optional()
    .when('isUnblockRequest', {
      is: true,
      then: schema => schema.required('Motivo es requerido'),
    })
    .max(255, 'El motivo no puede exceder los 255 caracteres'),
});
